var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgHome = function SvgHome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.444 3.5a.875.875 0 0 0-.864.875v19.25a.875.875 0 0 0 .875.875h19.25a.875.875 0 0 0 .875-.875V7.292a.877.877 0 0 0-1.167-.825L18.897 8.06l-4.292-3.219a.875.875 0 0 0-.786-.135L9.5 6.056 4.864 3.6a.875.875 0 0 0-.42-.1ZM5.33 5.83l3.674 1.945a.875.875 0 0 0 .67.061l4.24-1.325 4.307 3.231a.875.875 0 0 0 .817.126l3.792-1.34v4.527l-3.12 3.122a.536.536 0 0 1-.76 0L14.7 11.923a.875.875 0 0 0-.77-.245l-3.95.7a1.168 1.168 0 0 1-1.003-.296L5.33 8.662V5.83Z",
    fill: "#2B2F38"
  })));
};

export default SvgHome;